import JobAvailabilityGuard from '~components/Job/JobAvailabilityGuard';
import { Job } from '~hooks/useJob/models';

import { JobDetailsContainer } from '../JobDetailsContainer';

interface JobsTableExpandedBlockProps {
  job: Job;
  readOnly: boolean;
}

export default function JobsTableExpandedBlock({
  job,
  readOnly,
}: JobsTableExpandedBlockProps) {
  return (
    <JobAvailabilityGuard jobId={job.id}>
      <JobDetailsContainer details={job} readOnly={readOnly} />
    </JobAvailabilityGuard>
  );
}
